<app-uni-page [parent]="this" pageTitle="References: Manufacturers" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <div class="qb-list-actions">
    <p-button
      (click)="addManufacturer()"
      size="small"
      label="Add Manufacturer"
      icon="pi pi-plus"
      [disabled]="!this.user.isProductAdmin"
    ></p-button>
  </div>
  <div class="qb-layout-grid">
    <div class="w-full h-full">
      <app-ag-grid [gridOptions]="manufGridOptions"></app-ag-grid>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
